import { render, staticRenderFns } from "./IP_ByProject.vue?vue&type=template&id=6b38ed29&scoped=true&"
import script from "./IP_ByProject.vue?vue&type=script&lang=js&"
export * from "./IP_ByProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38ed29",
  null
  
)

export default component.exports